import { cn } from 'cn';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import SortingArrows from '#ui/components/SortingArrows/SortingArrows.js';
import Button from '../../Button/Button';
import type { ColumnSortDirection } from './columnHeaderControlsShared';

interface SortButtonProps {
  columnId: string;
  isSortable?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  getNextSortingOrder?: () => false | 'asc' | 'desc';
  sortDirection: ColumnSortDirection;
  label?: React.ReactNode;
}

export function SortButton({
  columnId,
  isSortable,
  onClick,
  getNextSortingOrder,
  sortDirection,
  label,
}: SortButtonProps) {
  const { t } = useTranslation('ui');
  const nextSortingOrder = getNextSortingOrder?.();

  if (!isSortable) return null;

  return (
    <Button
      compact
      hasIcon={!!label}
      data-testid={`sort-${columnId}`}
      theme="subtle"
      onClick={onClick}
      className="text-neutral-100 cursor-pointer self-center p-0.5 focus-visible:ring-blue-20 focus-visible:bg-transparent kunde:bg-transparent kunde:p-1 kunde:text-neutral-100 hover:kunde:bg-blue-10 hover:kunde:text-blue-100 active:kunde:bg-blue-10"
      title={
        nextSortingOrder === 'asc'
          ? t('table.sort.asc')
          : nextSortingOrder === 'desc'
            ? t('table.sort.desc')
            : nextSortingOrder === false
              ? t('table.sort.none')
              : undefined
      }
    >
      {label ? (
        <span
          className={cn(
            'uppercase truncate pr-1 typ-headline-2xs',
            'kunde:pr-1.5 kunde:normal-case kunde:font-semibold kunde:typ-headline-sm',
          )}
        >
          {label}
        </span>
      ) : null}
      <SortingArrows sorting={sortDirection} />
    </Button>
  );
}
